import { render } from "./BatteryChart.vue?vue&type=template&id=2ac2786e&ts=true"
import script from "./BatteryChart.vue?vue&type=script&lang=ts"
export * from "./BatteryChart.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__